import { render } from "./sim-connectivity.vue?vue&type=template&id=4dc39364&scoped=true"
import script from "./sim-connectivity.vue?vue&type=script&lang=js"
export * from "./sim-connectivity.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-4dc39364"

export default script